module.exports = __webpack_public_path__ + "img/discover.192f961f.svg";